import { render, staticRenderFns } from "./Dialog_ShowAdvisory.vue?vue&type=template&id=1f801352&scoped=true&"
import script from "./Dialog_ShowAdvisory.vue?vue&type=script&lang=js&"
export * from "./Dialog_ShowAdvisory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f801352",
  null
  
)

export default component.exports